import * as GatsbyApp from '../../utils/dataFetching/gatsbyFetcher';

export const checkUserStatus = (usernameUsedForLogin: string) =>
  GatsbyApp.post<object, any>(`user/check-status/${usernameUsedForLogin}`, {});
